/**
 * @file Engagement Data
 */
import {
  integerValueFormatter,
  percentCellFormatter,
} from 'src/const/statistics/formatters';
import { COLUMN_WIDTH } from 'src/const/column-width';
import { isEngagementMetricsWhite, isNativeMusicPromoteWhite } from 'src/const/whiteList';

/**
   * 每项对应的字段
   * {
   *    key: 对应的后端字段
   *    i18nPath: title 文案对应的 key
   *    hint:
   *    hoverKey: 用于表头hover内容，绝大部分列的类型可以由key计算得来，特殊的列需要写死
   *    min-width: 最小宽度
   *    sortable: 是否可排序
   *    align: 对齐方向
   *    header-align: header 对齐方向
   *    formatter(Option): 数据格式化函数
   * }
   */
export const EnumEngagementData = [
  {
    i18nPath: 'common_paid_followers',
    key: 'ad_net_follow',
    hint: 'campaign_hover_stat_data.paid_followers',
    hoverKey: 'campaign_hover_stat_data.paid_followers',
    'min-width': COLUMN_WIDTH.L,
    sortable: true,
    align: 'right',
    'header-align': 'right',
    formatter: integerValueFormatter, // 单元格数据格式化
    hide: () => !isEngagementMetricsWhite(),
  },
  {
    i18nPath: 'common_paid_likes',
    key: 'ad_net_like',
    hint: 'campaign_hover_stat_data.paid_likes',
    hoverKey: 'campaign_hover_stat_data.paid_likes',
    'min-width': COLUMN_WIDTH.L,
    sortable: true,
    align: 'right',
    'header-align': 'right',
    formatter: integerValueFormatter, // 单元格数据格式化
    hide: () => !isEngagementMetricsWhite(),
  },
  {
    i18nPath: 'common_paid_comments',
    key: 'ad_comment',
    hint: 'campaign_hover_stat_data.paid_comments',
    hoverKey: 'campaign_hover_stat_data.paid_comments',
    'min-width': COLUMN_WIDTH.L,
    sortable: true,
    align: 'right',
    'header-align': 'right',
    formatter: integerValueFormatter, // 单元格数据格式化
    hide: () => !isEngagementMetricsWhite(),
  },
  {
    i18nPath: 'common_paid_shares',
    key: 'ad_share',
    hint: 'campaign_hover_stat_data.paid_shares',
    hoverKey: 'campaign_hover_stat_data.paid_shares',
    'min-width': COLUMN_WIDTH.L,
    sortable: true,
    align: 'right',
    'header-align': 'right',
    formatter: integerValueFormatter, // 单元格数据格式化
    hide: () => !isEngagementMetricsWhite(),
  },
  {
    i18nPath: 'common_home_visited', // 主页访问数
    hint: 'campaign_hover_stat_data.home_visited',
    hoverKey: 'campaign_hover_stat_data.home_visited',
    key: 'ad_home_visited',
    sortable: true,
    align: 'right',
    'header-align': 'right',
    formatter: integerValueFormatter,
    hide: () => !isEngagementMetricsWhite(),
  },
  {
    i18nPath: 'common_home_visited_rate', // 主页访问率
    hint: 'campaign_hover_stat_data.home_visited_rate',
    hoverKey: 'campaign_hover_stat_data.home_visited_rate',
    key: 'ad_home_visited_rate',
    sortable: true,
    align: 'right',
    'header-align': 'right',
    formatter: percentCellFormatter,
    hide: () => !isEngagementMetricsWhite(),
  },
  {
    i18nPath: 'common_clicks_on_music_disc', // 点击音乐数
    hint: 'campaign_hover_stat_data.clicks_on_music_disc',
    hoverKey: 'campaign_hover_stat_data.clicks_on_music_disc',
    key: 'ies_music_click',
    sortable: true,
    align: 'right',
    'header-align': 'right',
    formatter: integerValueFormatter,
    hide: () => !isNativeMusicPromoteWhite(),
  },

  {
    i18nPath: 'common_anchor_click_count', //  Anchor Clicks
    hint: 'campaign_hover_stat_data.anchor_click_count',
    hoverKey: 'campaign_hover_stat_data.anchor_click_count',
    key: 'anchor_click_count',
    sortable: true,
    align: 'right',
    'header-align': 'right',
    formatter: integerValueFormatter,
  },
  {
    i18nPath: 'common_anchor_click_rate', // Anchor Click Rate
    hint: 'campaign_hover_stat_data.anchor_click_rate',
    hoverKey: 'campaign_hover_stat_data.anchor_click_rate',
    key: 'anchor_click_rate',
    sortable: true,
    align: 'right',
    'header-align': 'right',
    formatter: percentCellFormatter,
  },
];
